import { defineStyleConfig } from "@chakra-ui/react";
import Colors from "../../assets/colors/Colors";

const ButtonTheme = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    fontWeight: "500",
  },
  variants: {
    outline: {
      border: "1px solid",
      borderColor: Colors.commonCancleButtonRed,
      color: Colors.commonCancleButtonRed,
      _hover: {
        background: Colors.buttonOutlineHover,
        borderColor: Colors.buttonOutlineHover,
      },
      _focus: {
        background: Colors.buttonOutlineFocus,
        borderColor: Colors.inputBorderColor,
        boxShadow: "0px 0px 0px 3px" + Colors.taxInfo,
      },
      _press: {
        background: Colors.inputBorderColor,
      },
      _disabled: {
        backgroundColor: Colors.buttonOutlineDisable,
      },
      _focusVisible: {
        background: Colors.navbarLink,
        boxShadow: "0px 0px 0px 3px " + Colors.taxInfo,
      },
    },
    solid: {
      bg: Colors.taxInfo,
      color: Colors.loginAuthBackground,
      _hover: {
        background: Colors.taxInfo,
      },
      _active: {
        background: Colors.taxInfo,
      },
      _disabled: {
        _hover: {
          background: Colors.buttonHover,
        },
      },
      _focusVisible: {
        background: Colors.navbarLink,
        boxShadow: "0px 0px 0px 3px " + Colors.taxInfo,
      },
    },
    ghost: {
      fontWeight: "500",
      fontSize: "0.938rem",
      border: "1px solid",
      borderColor: Colors.modifierTable,
      borderRadius: "0.625rem",
      bg: Colors.ghostBackground,
      color: Colors.commonTextInfo,
    },
    posghost: {
      fontWeight: "300",
      fontSize: "0.94rem",
      border: "1px solid",
      borderColor: Colors.resetButton,
      borderRadius: "0.625rem",
      bg: Colors.campCardBgColor,
      color: Colors.commonCancleButtonRed,
    },
    avatar: {
      color: Colors.mainHeader,
      borderColor: Colors.inputBorderColor,
      fontSize: "sm",
      height: 12,
      _hover: {
        background: Colors.buttonOutlineHover,
      },
    },
    invoerror: {
      color: Colors.white,
      backgroundColor: Colors.commonCancleButtonRed,
      fontSize: "sm",
      lineHeight: 5,
      height: 12,
      _hover: {
        background: Colors.buttonOutlineHover,
      },
    },
    //new remove changes
    //     posoutline: {
    //   border: "1px solid",
    //   borderColor: Colors.primaryBrand, // Your primary brand color
    //   color: Colors.primaryBrand,
    //   bg: "transparent",
    //   borderRadius: "md",
    //   fontWeight: "semibold",
    //   transition: "all 0.2s ease-in-out",
    //   px: 6, // Horizontal padding
    //   py: 3, // Vertical padding
    //   _hover: {
    //     bg: Colors.primaryBrand + "10", // 10% opacity of brand color
    //     transform: "translateY(-1px)",
    //     boxShadow: "sm"
    //   },
    //   _active: {
    //     bg: Colors.primaryBrand + "20", // 20% opacity when pressed
    //     transform: "translateY(0)"
    //   },
    //   _focus: {
    //     boxShadow: `0 0 0 2px ${Colors.primaryBrand}40`, // 25% opacity glow
    //     outline: "none"
    //   },
    //   _disabled: {
    //     opacity: 0.6,
    //     cursor: "not-allowed",
    //     _hover: {
    //       bg: "transparent",
    //       transform: "none"
    //     }
    //   }
    // },
  },
});

export default ButtonTheme;
